import { createApiClient } from '@sw/api-client';
import { i18n } from '../i18n';

/**
 * Singleton api client del Client Portal. CSRF cookie = `cp_csrf` (debe matchear
 * la config del backend en ClientPortalAuthOptions).
 *
 * Envía `X-User-Language` con el idioma actual de react-i18next — backend lo
 * prioriza sobre `Accept-Language` (que es forbidden-header per fetch spec).
 */
export const api = createApiClient({
  // baseUrl vacío significa "mismo origin que el browser" — Vite proxy resuelve `/api`.
  // En prod (Amplify), el frontend está en el subdomain del workspace y el backend
  // también, así que paths relativos funcionan vía mismo origin.
  baseUrl: '',
  csrfCookieName: 'cp_csrf',
  csrfHeaderName: 'X-CSRF-Token',
  getCurrentLanguage: () => i18n.language,
});
